/**
 * T22.731: a guest who taps a wheel's heart is sent through the sign-in gate.
 * The gate used to forget WHY they were signing in, so the login page showed
 * the generic "Welcome Back!" and the favourite they asked for was never
 * applied once they were signed in.
 *
 * This module remembers that one pending favourite across the login round trip
 * (sessionStorage: same tab only, cleared once read) and names the login intent
 * so the Login page can say what signing in is for.
 */
export const LOGIN_INTENT_PARAM = "intent";
export const LOGIN_INTENT_FAVORITE = "favorite";

const KEY = "iyuga.pendingFavorite";
// A stale intent (guest wandered off and signed in much later) must not
// favourite a wheel out of the blue.
export const PENDING_FAVORITE_TTL_MS = 30 * 60 * 1000;

function store() {
  try {
    return typeof window !== "undefined" ? window.sessionStorage : null;
  } catch (e) {
    return null;
  }
}

export function savePendingFavorite(wheelId, now = Date.now()) {
  const s = store();
  if (!s || wheelId == null || wheelId === "") return;
  try {
    s.setItem(KEY, JSON.stringify({ wheelId: String(wheelId), at: now }));
  } catch (e) {
    // storage full / disabled: the favourite just is not replayed.
  }
}

/** Read AND clear the pending favourite. Returns the wheel id or null. */
export function takePendingFavorite(now = Date.now()) {
  const s = store();
  if (!s) return null;
  let raw = null;
  try {
    raw = s.getItem(KEY);
    s.removeItem(KEY);
  } catch (e) {
    return null;
  }
  if (!raw) return null;
  try {
    const { wheelId, at } = JSON.parse(raw) || {};
    if (!wheelId || typeof at !== "number") return null;
    if (now - at > PENDING_FAVORITE_TTL_MS) return null;
    return String(wheelId);
  } catch (e) {
    return null;
  }
}

export function hasPendingFavorite() {
  const s = store();
  try {
    return !!(s && s.getItem(KEY));
  } catch (e) {
    return false;
  }
}

/** Append `intent=<intent>` to a login URL ("/login" or "/login?redirect=..."). */
export function withLoginIntent(loginUrl, intent) {
  if (!intent) return loginUrl;
  const sep = loginUrl.includes("?") ? "&" : "?";
  return `${loginUrl}${sep}${LOGIN_INTENT_PARAM}=${encodeURIComponent(intent)}`;
}
